import NewReportForm from './NewReportForm.connect'

export default NewReportForm